import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import NavBar from "./components/shared/NavBar";
import Home from "./pages/Home"
import  FAQSection from "./components/FAQSection"
import ContactUs from "./components/ContactUs";
import Ingests from "./pages/Ingests"
import Pricing from "./components/Pricing";
import TryFree from "./components/shared/TryFree";
import Footer from "./components/shared/Footer";


function App() {
  return (
      <>
      <Router>
              <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/Pricing" element={<Pricing />} />
                  <Route path="/TryFree" element={<TryFree />} />
                  <Route path="/faqs" element={<FAQSection />} />
                  <Route path="/ingests" element={<Ingests />} />
              </Routes>
          <Footer/>

      </Router>
      </>
  );
}

export default App;
